import { GetterTree } from 'vuex';
import { State } from '@/manager/sync/store/state';
import { Operation } from '@/manager/sync/operation.model';
import { OperationTypeInterface } from '@/manager/sync/operationType.interface';

export interface Getters {
    getOperationList: Operation[];
    getOperationTypeList: OperationTypeInterface[];
}

export const getters: GetterTree<State, any> = {
    getOperationList: (state) => state.list,
    getOperationTypeList: (state) => state.operationTypeList,
    getOperation(state: State) {
        return (id: string) => {
            return state.list.find(
                (sync: any) => {
                    return sync.id === id;
                },
            );
        };
    },
    getKpiList: (state) => state.kpiList,
};
